import React, { createRef } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import EditText from '../../component/EditText';
import EditTextArea from '../../component/EditTextArea';
import SelectDate from '../../component/CalendarField';
import SelectFile from '../../component/SelectFileOld';
import MyButton from '../../component/Button';

import HookRoute from '../../HookRoute';

import { Get, Update, Create, Delete } from './http';

class FormsElements extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                id: 0,
                title: '',
                content: '',
                files: '',
                status: 'OPENED',
            },
        };
    }

    /**
     * 정보
     */
    resultGet = response => {
        this.setState({
            data: response,
        });
    };

    /**
     * 저장
     * @param e
     */
    clickSave = e => {
        const { data } = this.state;

        if (this.id) {
            Update(this, this.id, data, this.resultSave);
        } else {
            Create(this, data, this.resultSave);
        }
    };

    /**
     * 저장하기
     */
    resultSave = res => {
        alert('저장이 완료 되었습니다.');
        window.location = '/a/board/list';
    };

    /**
     * 삭제
     * @param  e
     */
    clickDelete = e => {
        var result = window.confirm('삭제 하시겠습니까?');
        if (result) {
            Delete(this, this.id, this.resultDelete);
        } else {
        }
    };

    /**
     * 삭제하기
     */
    resultDelete = res => {
        alert('삭제가 완료 되었습니다.');
        window.location = '/a/board/list';
    };

    render() {
        const { data } = this.state;

        return (
            <HookRoute
                load={params => {
                    const { id } = params;
                    this.id = id;
                    if (this.id) {
                        Get(this, this.id, this.resultGet.bind(this));
                    }
                }}
            >
                <Row>
                    <Col>
                        <Card className="white">
                            <Card.Header>
                                <Card.Title as="h5">{this.id ? '자료실 정보' : '자료실 등록'}</Card.Title>
                            </Card.Header>

                            <Card.Body>
                                <div className="sort_input">
                                    <EditText
                                        title={'제목'}
                                        value={data.title}
                                        placeholder="제목을 입력하세요."
                                        onChange={e => {
                                            data.title = e.target.value;
                                            this.setState(data);
                                        }}
                                    />

                                    <EditTextArea
                                        title={'내용'}
                                        value={data.content}
                                        placeholder="내용을 입력하세요."
                                        onChange={e => {
                                            data.content = e.target.value;
                                            this.setState(data);
                                        }}
                                    />

                                    <SelectFile
                                        title={'파일첨부'}
                                        value={data.files}
                                        show_name={true}
                                        onChange={file => {
                                            data.files = file;
                                            this.setState(data);
                                        }}
                                    />
                                </div>
                            </Card.Body>
                        </Card>

                        <div className="voting_fixed_bottom">
                            <MyButton
                                title={'목록'}
                                variant="primary"
                                onClick={e => {
                                    window.location = '/a/board/list';
                                }}
                            />
                            {this.id && <MyButton title={'삭제'} variant="danger" onClick={this.clickDelete} />}
                            <MyButton title={!this.id ? '등록' : '저장'} variant="primary" onClick={this.clickSave} />
                        </div>
                    </Col>
                </Row>
            </HookRoute>
        );
    }
}

export default FormsElements;
